"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPinnedContentLesson = addPinnedContentLesson;
exports.addPinnedContentModule = addPinnedContentModule;
exports.deletePinnedContentLesson = deletePinnedContentLesson;
exports.deletePinnedContentModule = deletePinnedContentModule;
exports.movePinnedContentModule = movePinnedContentModule;
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getBase = function getBase() {
  return {
    topLevel: []
  };
};
function addPinnedContentModule(formikBag, moduleIndex) {
  var prefix = formikBag.values.currentPrefix;
  var curr = (0, _get2["default"])(formikBag.values, prefix + '.pinnedContent', getBase()) || getBase();
  var updated = _objectSpread(_objectSpread({}, curr), {}, _defineProperty({}, moduleIndex, getBase()));
  formikBag.setFieldValue(prefix + '.pinnedContent', updated);
}
function addPinnedContentLesson(formikBag, moduleIndex, surveyHandle) {
  var prefix = formikBag.values.currentPrefix;
  var curr = (0, _get2["default"])(formikBag.values, "".concat(prefix, ".pinnedContent"), getBase()) || getBase();
  var updated = (0, _cloneDeep2["default"])(curr);
  (0, _set2["default"])(updated, "".concat(moduleIndex, ".").concat(surveyHandle), []);
  formikBag.setFieldValue(prefix + '.pinnedContent', updated);
}
function deletePinnedContentModule(formikBag, moduleIndex) {
  var prefix = formikBag.values.currentPrefix;
  var curr = (0, _get2["default"])(formikBag.values, prefix + '.pinnedContent', getBase()) || getBase();

  // deep copy for state to force React to re-render
  var updated = (0, _cloneDeep2["default"])(curr);

  // subtract 1 so we don't count `topLevel` key
  var numOfModulesOld = Object.keys(curr).length - 1;
  for (var i = 0; i < numOfModulesOld; i++) {
    if (i >= moduleIndex) {
      delete updated[i];
      if (i < numOfModulesOld - 1) {
        updated[i] = updated[i + 1];
      }
    }
  }
  formikBag.setFieldValue(prefix + '.pinnedContent', updated);
}
function deletePinnedContentLesson(formikBag, moduleIndex, surveyHandle) {
  var prefix = formikBag.values.currentPrefix;
  var curr = (0, _get2["default"])(formikBag.values, prefix + '.pinnedContent', getBase()) || getBase();

  // deep copy for state to force React to re-render
  var updated = (0, _cloneDeep2["default"])(curr);
  delete updated[moduleIndex][surveyHandle];
  formikBag.setFieldValue(prefix + '.pinnedContent', updated);
}
function movePinnedContentModule(formikBag, moduleIndexFrom, moduleIndexTo) {
  var prefix = formikBag.values.currentPrefix;
  var curr = (0, _get2["default"])(formikBag.values, prefix + '.pinnedContent', getBase()) || getBase();
  var numOfModules = ((0, _get2["default"])(formikBag.values, "".concat(prefix, ".modules"), []) || []).length;

  // deep copy for state to force React to re-render
  var updated = (0, _cloneDeep2["default"])(curr);
  for (var i = 0; i < numOfModules; i++) {
    var valToPush = curr[i];
    if (i === moduleIndexTo) {
      valToPush = curr[moduleIndexFrom];
    }
    // moving item up the list
    else if (moduleIndexTo < moduleIndexFrom && i > moduleIndexTo && i <= moduleIndexFrom) {
      if (i > moduleIndexTo && i <= moduleIndexFrom) {
        valToPush = curr[i - 1];
      }
    }
    // moving item down the list
    else if (moduleIndexTo > moduleIndexFrom && i >= moduleIndexFrom && i < moduleIndexTo) {
      valToPush = curr[i + 1];
    }
    updated[i] = valToPush;
  }
  formikBag.setFieldValue(prefix + '.pinnedContent', updated);
}